module.exports = __webpack_public_path__ + "static/media/slide.f133d16a.png";